import { sendApiRequest } from './api';
import { submitQualityCheck } from './genaiQueriesV2';
import { applicationActionTypes } from '@constants/actionTypes';

export const logUserAction = async (form) => {
  const URL = `v1/current_user/user_action`;
  const { status, error } = await sendApiRequest('post', URL, form);
  if (status === 200) {
    return {
      ok: true,
    };
  } else {
    return {
      ok: false,
      message: error,
    };
  }
};

export const fetchStaticCopy = () => {
  return async (dispatch) => {
    const response = await sendApiRequest('get', 'v1/static', null, null);
    const { status, data } = response;
    if (status === 200) {
      dispatch({
        type: applicationActionTypes.setStaticCopy,
        payload: data,
      });
    }
    return response;
  };
};

export const runQualityCheck = (queryRunId) => {
  submitQualityCheck({ queryRunId });
};
